import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=3fb36d13&"
import script from "./Logo.js?vue&type=script&lang=js&"
export * from "./Logo.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fb36d13')) {
      api.createRecord('3fb36d13', component.options)
    } else {
      api.reload('3fb36d13', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=3fb36d13&", function () {
      api.rerender('3fb36d13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Logo/Logo.vue"
export default component.exports